<div class="card">
    <div class="-mt-5">
    <p-tabs value="0" (valueChange)="selectTab($event)">
        <p-tablist>
            <p-tab value="0">Overview</p-tab>
            <p-tab value="6">Documents</p-tab>
        </p-tablist>

        <p-tabpanels  style="height: 78vh; overflow-y: auto;">

            <!-- ✅ Overview -->
            <p-tabpanel value="0" class="p-4 overflow-y-auto"
            >
                <app-student-overview 
                [editLeadData]="editLeadData"
                [fullUser]="fullUser"
                [allLeadFeilds]="allLeadFeilds"
                [users]="users"

                [studentDetails]="studentDetails" [allCourses]="allCourses"
                    [academicYearList]="academicYearList" [departmentList]="departmentList" [batchList]="batchList"
                    [feeCategoryList]="feeCategoryList" [hostelCategoryList]="hostelCategoryList"
                    [student_profile_stage]="student_profile_stage"
                    [editAdmissionData]="studentDetails"
                    [transportRouteList]="transportRouteList" [scholarshipTypeList]="scholarshipTypeList"
                    (onUpdate)="handleUpdate($event)">
                </app-student-overview>
            </p-tabpanel>

          

            
            <p-tabpanel value="6" class="p-4 text-center text-gray-500 ">
                <app-update-student-document [studentDetails]="studentDetails"
                ></app-update-student-document>
            </p-tabpanel>

        </p-tabpanels>
    </p-tabs>
    </div>
</div>